import { apiFetch } from "@/lib/api-fetch";
import type { LibraryEntry, Game } from "@/types";

export interface LibraryEntryWithGame extends LibraryEntry {
  game: Game | null;
}

export async function getLibraryEntriesByUserId(userId: string): Promise<LibraryEntry[]> {
  const res = await apiFetch(`/api/library?userId=${encodeURIComponent(userId)}`);
  if (!res.ok) return [];
  const data = (await res.json()) as { entries?: LibraryEntry[] };
  return data.entries ?? [];
}

export async function getLibraryEntriesWithGamesByUserId(userId: string): Promise<LibraryEntryWithGame[]> {
  const res = await apiFetch(
    `/api/library?userId=${encodeURIComponent(userId)}&withGames=1`
  );
  if (!res.ok) return [];
  const data = (await res.json()) as { entriesWithGames?: LibraryEntryWithGame[] };
  return data.entriesWithGames ?? [];
}

export async function getLibraryEntryByUserAndGame(
  userId: string,
  gameId: string
): Promise<LibraryEntry | null> {
  const res = await apiFetch(
    `/api/library?userId=${encodeURIComponent(userId)}&gameId=${encodeURIComponent(gameId)}`
  );
  if (!res.ok) return null;
  const data = (await res.json()) as { entry?: LibraryEntry | null };
  return data.entry ?? null;
}
